//
// Home Button

gameRulesButton = {};

gameRulesButton.create = function() {
	var button = new PIXI.Container();
	button._rulesData = {
		URL: ""
	};
    button._closeButtonTranslationPhrase = "t_close";

	InputHelpers.addGenerics(button);
    InputHelpers.addAutoplayFlag(button);
    InputHelpers.addCanSpinFlag(button);

	button.canEnable = function() {
		return (this._flags.canSpin && !this._flags.autoplayStarted && !this._flags.modal.active);
	};

	button.canShow = function() {
		return (this._rulesData.URL !== "");
	};

	button.parseGameConfig = function(gameConfigTask) {
		if ( (typeof(gameConfigTask.data.gameRulesUrl) !== "undefined") && (gameConfigTask.data.gameRulesUrl !== "") ) {
			this._rulesData.URL = gameConfigTask.data.gameRulesUrl;
		}
	};

	button.onPressedCallback = function() {
        htmlViewer.show(this._rulesData.URL, button._closeButtonTranslationPhrase );
		if (button.soundName !== "") button.playSound();
	};

	messageBus.subscribe("spinner:GameConfigEvent", button.parseGameConfig.bind(button));

	return button;
};

gameRulesButton.initialise = function(json, object) {
	object.soundName = json.soundName || "";
	if (checkForDefined(json.translationPhrase)) {
        button._closeButtonTranslationPhrase = json.closeButtonTranslationPhrase;
	}
};

gameRulesButton.getFilesRequired = function() {
	return [];
};

resourceManager.registerObjectType("gameRulesButton", gameRulesButton.create, gameRulesButton.initialise, gameRulesButton.getFilesRequired);